"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.setGlobalSkipErrorValidation = exports.setOnUnauthorizedError = void 0;
var baseHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=UTF-8',
};
var onUnauthorizedError = null;
var globalSkipErrorValidation = false;
var setOnUnauthorizedError = function (callback) {
    onUnauthorizedError = callback;
};
exports.setOnUnauthorizedError = setOnUnauthorizedError;
var setGlobalSkipErrorValidation = function (value) {
    globalSkipErrorValidation = value;
};
exports.setGlobalSkipErrorValidation = setGlobalSkipErrorValidation;
var fetchApi = function (url, options, returnResponse, skipErrorValidation) { return __awaiter(void 0, void 0, void 0, function () {
    var skipErrors;
    return __generator(this, function (_a) {
        skipErrors = skipErrorValidation || globalSkipErrorValidation;
        return [2 /*return*/, fetch("".concat(url), options)
                .catch(function (error) {
                if (skipErrors)
                    return null;
                throw new Error('Network error');
            })
                .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var result, didRedirect, json, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (response === null) {
                                result = { success: false, error: 'fetchApiNetworkError' };
                                if (returnResponse) {
                                    return [2 /*return*/, { response: null, json: result }];
                                }
                                return [2 /*return*/, result];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            if (onUnauthorizedError && response.status === 401) {
                                didRedirect = onUnauthorizedError();
                                if (didRedirect)
                                    return [2 /*return*/, null];
                            }
                            return [4 /*yield*/, response.json()];
                        case 2:
                            json = _a.sent();
                            if (returnResponse) {
                                return [2 /*return*/, { response: response, json: json }];
                            }
                            if (skipErrors) {
                                if (!response.ok) {
                                    return [2 /*return*/, __assign(__assign({}, json), { success: false })];
                                }
                                return [2 /*return*/, json];
                            }
                            if (!response.ok || json.error) {
                                throw new Error(json.error || json.errors);
                            }
                            return [2 /*return*/, json];
                        case 3:
                            e_1 = _a.sent();
                            if (skipErrors) {
                                return [2 /*return*/, { success: false, error: 'fetchApiGeneralError' }];
                            }
                            if (e_1 instanceof SyntaxError) {
                                throw new Error('Something went wrong');
                            }
                            throw e_1;
                        case 4: return [2 /*return*/];
                    }
                });
            }); })];
    });
}); };
var callFetchApi = function (method, params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, token, body, mockFunc, returnResponse, skipErrorValidation, headers, isMockMode, reqHeaders, options, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = params.url, token = params.token, body = params.body, mockFunc = params.mockFunc, returnResponse = params.returnResponse, skipErrorValidation = params.skipErrorValidation, headers = params.headers;
                isMockMode = process.env.CB_MODE === 'mock';
                if (isMockMode)
                    return [2 /*return*/, mockFunc === null || mockFunc === void 0 ? void 0 : mockFunc()];
                reqHeaders = headers ? __assign(__assign({}, baseHeaders), headers) : baseHeaders;
                options = { method: method, headers: reqHeaders, credentials: 'include' };
                if (token) {
                    options.headers = __assign(__assign({}, reqHeaders), { Authorization: token });
                }
                if (body && method !== 'GET') {
                    options.body = JSON.stringify(body);
                }
                return [4 /*yield*/, fetchApi(url, options, returnResponse, skipErrorValidation)];
            case 1:
                data = _a.sent();
                return [2 /*return*/, data];
        }
    });
}); };
var requests = {
    get: function (params) { return callFetchApi('GET', params); },
    patch: function (params) { return callFetchApi('PATCH', params); },
    put: function (params) { return callFetchApi('PUT', params); },
    post: function (params) { return callFetchApi('POST', params); },
    delete: function (params) { return callFetchApi('DELETE', params); },
};
var downloadFile = function (url) {
    window.open(url);
};
exports.downloadFile = downloadFile;
exports.default = requests;
